import { useGetCasesFilterOptionsQuery } from 'queries/cases/queries';

export const buildOwnersOptions = (owners: string[]) =>
  owners.map((user) => {
    const username = user.split('@')[0].toLowerCase();
    return { label: username, value: user };
  });

export const useFilterCaseOptions = () => {
  const { data, isLoading } = useGetCasesFilterOptionsQuery();

  const ownersOptions = buildOwnersOptions(data?.owners ?? []);

  const assetsOptions =
    data?.assets?.map((vessel) => ({
      label: vessel.name,
      value: vessel.id,
    })) ?? [];

  const categories = data?.categories ?? [];

  return {
    data: { assetsOptions, categories, ownersOptions },
    isLoading,
  };
};
